import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { deleteDeprecationPlan } from '../service/deprecationPlanService'
import { deprecationPlanQueryKeys } from '../queries/deprecationPlanQueryKeys'

export const useDeleteDeprecationPlan = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  const { message } = App.useApp()

  return useMutation({
    mutationKey: ['budget', 'deprecationPlan', 'delete'],
    mutationFn: (id: number) => deleteDeprecationPlan(companyId, id),
    onSuccess: () => {
      message.success(t('messages:deleteSuccess', 'Deleted successfully'))
      // Note: Financial statements invalidation is handled by global mutation observer
      queryClient.invalidateQueries({ queryKey: deprecationPlanQueryKeys.lists() })
    },
    onError: () => {
      message.error(t('messages:deleteError', 'Failed to delete'))
    }
  })
}
